import { ConfigModel } from '@bymason/controller-api-hooks';

export const TEMPLATE_OS_CONFIG: ConfigModel = {
  os: {
    configurations: {
      'mason-management': {
        disable_status_bar: true,
        disable_camera: true,
        disable_screen_capture: true,
      },

      settings: {
        config_default_tile_list: ['wifi', 'bluetooth', 'sim', 'about'],
      },

      android: {
        config_lowBatteryWarningLevel: 25,
        config_supportAutoRotation: false,
        config_shortPressOnPowerBehavior: 1,
        config_cameraDoubleTapPowerGestureEnabled: false,
      },

      'mason-fota': {
        config_allow_download_over_metered: true,
        config_update_prompt_prior_to_install: false,
        config_show_download_in_downloads_ui: true,
      },

      'mason-app-updater': {
        config_allow_download_over_metered: true,
      },
    },
    name: '',
    version: 'latest',
  },
};
